import React from 'react'
import styles from './ListError.module.scss'

export const ListError = () => {
  return (
    <p className={styles.ErrorLabel}>Something went wrong, we couldn’t load the data. Please try again later.</p>
  )
}
